import React from "react";
import { LotteryContainer } from "./style";
import { Col, Container, Row } from "react-bootstrap";
import { useFormik } from "formik";
import Input from "components/input";
import Button from "components/button";
import { queryLottery } from "api/product";
import Modal from "components/modal";
const validate = (values) => {
  const errors = {};
  if (!values.phone) {
    errors.first_name = "اجباری است";
  }
  if (!values.national_code) {
    errors.last_name = "اجباری است";
  }
  return errors;
};
const Lottery = () => {
  const [loading, setLoading] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const formik = useFormik({
    initialValues: {
      phone: "",
      national_code: "",
    },
    validate,
    onSubmit: (values) => {
      setLoading(true);
      queryLottery(values)
        .then((res) => {
          setLoading(false);
          setModalData(res.data.message);
        })
        .catch((err) => {
          setLoading(false);
        });
    },
    validateOnChange: false,
  });
  return (
    <LotteryContainer>
      <Container>
        <Row>
          <Col sm={12} md={8}>
            <div className="caption">
              جهت استعلام وضعیت ثبت نام خود در سامانه یکپارچه خودرو اطلاعات خود را در فرم مقابل وارد کنید
            </div>
          </Col>
          <Col sm={12} md={4}>
            <div className="query">
              <form onSubmit={formik.handleSubmit}>
                <div className="form-item">
                  <Input
                    name="national_code"
                    onChange={formik.handleChange}
                    value={formik.values.national_code}
                    label="کد ملی:"
                    type="number"
                    ltr
                    error={formik.errors.national_code}
                    required
                  />
                </div>
                <div className="form-item">
                  <Input
                    name="phone"
                    onChange={formik.handleChange}
                    value={formik.values.phone}
                    label="شماره همراه:"
                    type="number"
                    ltr
                    error={formik.errors.phone}
                    required
                  />
                </div>

                <div className="buttons">
                  <Button title="استعلام" type="submit" loading={loading} />
                </div>
              </form>
            </div>
          </Col>
        </Row>
        <Modal close={() => setModalData(null)} status={modalData}>
          <div dangerouslySetInnerHTML={{ __html: modalData }} />
        </Modal>
      </Container>
    </LotteryContainer>
  );
};
export default Lottery;
